class BlogItem {

    constructor (id, headline, date, imageUrl, introduction, leadIn, para1, para2, para3, para4, para5, conclusion, feedback, references, display, featured) {
        this.id = id;
        this.headline = headline;
        this.date = date;
        this.imageUrl = imageUrl;
        this.introduction = introduction;
        this.leadIn = leadIn;
        this.para1 = para1;
        this.para2 = para2;
        this.para3 = para3;
        this.para4 = para4;
        this.para5 = para5;
        this.conclusion = conclusion;
        this.feedback = feedback;
        this.references = references;
        this.display = display;
        this.featured = featured;
    }
}

export default BlogItem;